/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ChangeLogTypes } from './change-log-types';


export interface PoolCommissionChangeLogResponseItem { 
    oldValue?: number | null;
    newValue?: number | null;
    type: ChangeLogTypes;
    currencyId?: number | null;
    currencyTicker?: string | null;
    createdDate: string;
    createdBy: string;
    createdByName?: string | null;
    createdByRole?: string | null;
    targetUserId?: string | null;
    targetUserName?: string | null;
}



